import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { ArrowUpRight, Clock } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { Eyebrow, SectionTitle, GoldButton } from "@/components/Section";
import { categoryTone } from "@/pages/Insights";

import { API } from "@/lib/api";

export const InsightsTeaser = () => {
  const [articles, setArticles] = useState([]);

  useEffect(() => {
    axios
      .get(`${API}/insights/articles`)
      .then((res) => setArticles(res.data.slice(0, 3)))
      .catch(() => setArticles([]));
  }, []);

  if (articles.length === 0) return null;

  return (
    <section className="relative py-24 lg:py-32 bg-[#F2EEE7] overflow-hidden" data-testid="insights-teaser">
      <div className="absolute inset-x-0 top-0 hairline" />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <Reveal className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6">
          <div className="max-w-2xl">
            <Eyebrow tone="#C5A059">Άρθρα & Οπτικές</Eyebrow>
            <SectionTitle className="mt-6">Ιδέες που <span className="italic text-[#C26D52]">εφαρμόζονται.</span></SectionTitle>
          </div>
          <GoldButton to="/insights" testId="insights-teaser-link" variant="outline">Όλα τα άρθρα</GoldButton>
        </Reveal>
        <div className="mt-14 rounded-[32px] bg-white border border-[#0E1B31]/[0.07] overflow-hidden shadow-[0_40px_90px_-60px_rgba(14,27,49,0.4)] divide-y divide-[#0E1B31]/[0.07]">
          {articles.map((a, i) => {
            const tone = categoryTone(a.category);
            return (
              <Reveal key={a.slug} delay={i * 0.06}>
                <Link
                  to={`/insights/${a.slug}`}
                  data-testid={`insight-teaser-${a.slug}`}
                  className="group grid grid-cols-1 md:grid-cols-12 gap-4 md:gap-8 items-center px-7 py-7 lg:px-10 lg:py-8 hover:bg-[#F8F6F0] transition-colors duration-300"
                >
                  <div className="md:col-span-2 flex items-center gap-4">
                    <span className="font-display text-4xl font-semibold" style={{ color: `${tone}` }}>0{i + 1}</span>
                    <span className="font-mono-brand text-[10px] tracking-[0.25em] uppercase text-[#6B7A8F]">{a.category}</span>
                  </div>
                  <h3 className="md:col-span-7 font-display text-xl sm:text-2xl lg:text-[1.7rem] font-semibold text-[#0E1B31] leading-snug group-hover:text-[#2C4A6F] transition-colors">
                    {a.title}
                  </h3>
                  <div className="md:col-span-3 flex items-center justify-between md:justify-end gap-6">
                    <span className="inline-flex items-center gap-1.5 text-[12px] text-[#6B7A8F]"><Clock className="h-3 w-3" /> {a.reading_time}</span>
                    <span className="flex h-11 w-11 items-center justify-center rounded-full border border-[#0E1B31]/10 text-[#0E1B31] transition-all duration-300 group-hover:bg-[#0E1B31] group-hover:text-white group-hover:border-transparent">
                      <ArrowUpRight className="h-4 w-4" />
                    </span>
                  </div>
                </Link>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
};
